var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticStyle:{"padding-left":"0px"},attrs:{"label":_vm.label,"color":"red","hide-details":"","prepend-icon":"mdi-help-circle"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})}
var staticRenderFns = []

export { render, staticRenderFns }